export const GREEN_ZONES: google.maps.LatLngLiteral[][] = [
  [
    { lat: 25.306077180001964, lng: 55.33461028067805 },
    { lat: 25.301096425341765, lng: 55.330394417373256 },
    { lat: 25.298263930547165, lng: 55.32898497294376 },
    { lat: 25.296024906402614, lng: 55.32678090786083 },
    { lat: 25.28824172995982, lng: 55.316441774155194 },
    { lat: 25.274602865608017, lng: 55.29293570209606 },
    { lat: 25.27395398176045, lng: 55.292002838202094 },
    { lat: 25.273168617195797, lng: 55.29117778001706 },
    { lat: 25.27000879255332, lng: 55.28918843706087 },
    { lat: 25.265414719498626, lng: 55.28544117202568 },
    { lat: 25.256226573389235, lng: 55.277946641955296 },
    { lat: 25.23774819564009, lng: 55.263098654710326 },
    { lat: 25.16268187896248, lng: 55.206106303086344 },
    { lat: 25.14941543198676, lng: 55.19468647871194 },
    { lat: 25.115136069156048, lng: 55.16436246172009 },
    { lat: 25.11974719882901, lng: 55.154804195262926 },
    { lat: 25.125177869506704, lng: 55.155272257723794 },
    { lat: 25.128188799331795, lng: 55.154723494180345 },
    { lat: 25.131187208469953, lng: 55.15388431092429 },
    { lat: 25.13600318913712, lng: 55.1511321739861 },
    { lat: 25.139572638940223, lng: 55.146219446127944 },
    { lat: 25.140890772568653, lng: 55.14277406632863 },
    { lat: 25.141529495450673, lng: 55.139091683362025 },
    { lat: 25.14156461388123, lng: 55.135026234699595 },
    { lat: 25.140940913092585, lng: 55.13140043371506 },
    { lat: 25.140072633091798, lng: 55.12841726713705 },
    { lat: 25.138848623162936, lng: 55.12543381265785 },
    { lat: 25.135911199570153, lng: 55.12018619911066 },
    { lat: 25.131056547170118, lng: 55.11501839291455 },
    { lat: 25.125826149230175, lng: 55.11113027087355 },
    { lat: 25.12137074099875, lng: 55.10945931681114 },
    { lat: 25.11716557464169, lng: 55.10841483570019 },
    { lat: 25.11328991119198, lng: 55.10830681485375 },
    { lat: 25.109335820850212, lng: 55.1089494776065 },
    { lat: 25.106482201207484, lng: 55.11002856528379 },
    { lat: 25.10377725060187, lng: 55.11157283151208 },
    { lat: 25.099671056029038, lng: 55.11589482703511 },
    { lat: 25.097298866123886, lng: 55.12206116574531 },
    { lat: 25.096927375534953, lng: 55.12592781147988 },
    { lat: 25.097503697380823, lng: 55.131720472395585 },
    { lat: 25.09902060642037, lng: 55.13632563830048 },
    { lat: 25.096350385479873, lng: 55.134803670130566 },
    { lat: 25.094070004629565, lng: 55.130550934718975 },
    { lat: 25.09262840515417, lng: 55.12694724909643 },
    { lat: 25.090425775830212, lng: 55.123657429994466 },
    { lat: 25.083680413718366, lng: 55.12103961520119 },
    { lat: 25.08048939729929, lng: 55.118259350899876 },
    { lat: 25.08008479651665, lng: 55.11868931984348 },
    { lat: 25.079674987982315, lng: 55.11845653755586 },
    { lat: 25.0790228821862, lng: 55.11911548672491 },
    { lat: 25.077880202314585, lng: 55.120433385063 },
    { lat: 25.07527173935516, lng: 55.12360422061431 },
    { lat: 25.073164368248502, lng: 55.122901213209715 },
    { lat: 25.071414477595823, lng: 55.12366808912845 },
    { lat: 25.06500561699442, lng: 55.13315010226978 },
    { lat: 25.035875988218596, lng: 55.10720788611455 },
    { lat: 25.028945388864393, lng: 55.10210580296294 },
    { lat: 25.021203685551626, lng: 55.09867044055189 },
    { lat: 24.98800562683797, lng: 55.09316562070897 },
    { lat: 24.97416798072807, lng: 55.14199413208408 },
    { lat: 24.963604496681317, lng: 55.13831012285989 },
    { lat: 24.95419260674361, lng: 55.13399464388875 },
    { lat: 24.939109204840253, lng: 55.12378050861621 },
    { lat: 24.925894523115744, lng: 55.11198089267554 },
    { lat: 24.90885307954307, lng: 55.0882972321555 },
    { lat: 24.89159723763659, lng: 55.1012188619176 },
    { lat: 24.880708445955868, lng: 55.11851806892818 },
    { lat: 24.871168740873543, lng: 55.1370368687255 },
    { lat: 24.86609127948654, lng: 55.13316011435977 },
    { lat: 24.861785966579337, lng: 55.1283282939307 },
    { lat: 24.859715821122528, lng: 55.12985577649121 },
    { lat: 24.86076082961433, lng: 55.13338254651771 },
    { lat: 24.86152163216103, lng: 55.13444385858544 },
    { lat: 24.860327416154252, lng: 55.13559751466653 },
    { lat: 24.858106539869112, lng: 55.13676591732266 },
    { lat: 24.854781940663255, lng: 55.13707115433497 },
    { lat: 24.853831867375938, lng: 55.139039871779175 },
    { lat: 24.85282593316935, lng: 55.1404545251399 },
    { lat: 24.85103793788412, lng: 55.14217699187947 },
    { lat: 24.84849579244171, lng: 55.14343773854891 },
    { lat: 24.856027536047318, lng: 55.152824833068316 },
    { lat: 24.84907480482918, lng: 55.162080667590345 },
    { lat: 24.85854729517277, lng: 55.173118994487254 },
    { lat: 24.866685208825196, lng: 55.18266930759934 },
    { lat: 24.87766862871233, lng: 55.19206538914435 },
    { lat: 24.884751098460207, lng: 55.19825367159592 },
    { lat: 24.89291632124966, lng: 55.20454167745627 },
    { lat: 24.903089115668273, lng: 55.21232614289012 },
    { lat: 24.915937037754162, lng: 55.21994193594192 },
    { lat: 24.919933946048772, lng: 55.2218706397302 },
    { lat: 24.92901614212312, lng: 55.22599858152169 },
    { lat: 24.978406260437033, lng: 55.24059442865054 },
    { lat: 24.984531670169105, lng: 55.243548577740555 },
    { lat: 24.989637190676998, lng: 55.24717849096573 },
    { lat: 24.998623950366195, lng: 55.25556405053811 },
    { lat: 25.01368245869518, lng: 55.2720004783374 },
    { lat: 24.99068327913976, lng: 55.29772722694371 },
    { lat: 24.99824249808492, lng: 55.30427628250475 },
    { lat: 25.006330149607788, lng: 55.31300211302161 },
    { lat: 25.029790873861785, lng: 55.28924033414093 },
    { lat: 25.042574824923452, lng: 55.30187357327634 },
    { lat: 25.053235529559466, lng: 55.31255481802899 },
    { lat: 25.05819049794001, lng: 55.319267627285384 },
    { lat: 25.06239658039429, lng: 55.328457660571246 },
    { lat: 25.06485695763172, lng: 55.33614373320286 },
    { lat: 25.065821439423573, lng: 55.34383001548608 },
    { lat: 25.069246298452853, lng: 55.3592023704009 },
    { lat: 25.075253227086538, lng: 55.373958041033845 },
    { lat: 25.083053594376956, lng: 55.38500410343367 },
    { lat: 25.125828423760094, lng: 55.44936110203793 },
    { lat: 25.165075121238964, lng: 55.49589106033223 },
    { lat: 25.175690468795167, lng: 55.512491239493016 },
    { lat: 25.18768170251199, lng: 55.52831900668178 },
    { lat: 25.19939061245268, lng: 55.54242378501685 },
    { lat: 25.20609045186288, lng: 55.54855814307957 },
    { lat: 25.214077662282932, lng: 55.5544940142083 },
    { lat: 25.23405036383103, lng: 55.564172603892445 },
    { lat: 25.302253915599252, lng: 55.386270523272 },
    { lat: 25.297811657514146, lng: 55.37747011416488 },
    { lat: 25.295564682580093, lng: 55.3738840319929 },
    { lat: 25.296248710172435, lng: 55.37258028179025 },
    { lat: 25.29651760616821, lng: 55.37080210515444 },
    { lat: 25.29694382398253, lng: 55.367000824312015 },
    { lat: 25.29717931442684, lng: 55.36484522259602 },
    { lat: 25.297374202724882, lng: 55.363497971523344 },
    { lat: 25.297471646756932, lng: 55.36283332766064 },
    { lat: 25.297439165421608, lng: 55.36234831727501 },
    { lat: 25.297138712659176, lng: 55.36188127023658 },
    { lat: 25.29626252752142, lng: 55.361220613977935 },
    { lat: 25.289781845135536, lng: 55.3599173704859 },
    { lat: 25.290680897786984, lng: 55.35484873409584 },
    { lat: 25.294287227738423, lng: 55.34980641900566 },
    { lat: 25.297757368493265, lng: 55.345591946690035 },
    { lat: 25.306077180001964, lng: 55.33461028067805 },
  ],
  [
    { lat: 24.826908556815255, lng: 55.129765036889296 },
    { lat: 24.899269618360023, lng: 55.07251939075539 },
    { lat: 24.868959918383524, lng: 55.02504209860797 },
    { lat: 24.79841747807005, lng: 55.08535098300359 },
    { lat: 24.826908556815255, lng: 55.129765036889296 },
  ],
];

export const RED_ZONES: google.maps.LatLngLiteral[][] = [
  [
    { lat: 25.24006369890644, lng: 55.40386259439336 },
    { lat: 25.240278960428753, lng: 55.39750200844202 },
    { lat: 25.24569982359445, lng: 55.38768158354216 },
    { lat: 25.25446175347507, lng: 55.3869045455761 },
    { lat: 25.266336142132317, lng: 55.366799130569035 },
    { lat: 25.267475367884373, lng: 55.36414007577548 },
    { lat: 25.267877321229776, lng: 55.359747571528914 },
    { lat: 25.268468426671973, lng: 55.35606100546423 },
    { lat: 25.269343257443694, lng: 55.354596837381536 },
    { lat: 25.274955612888135, lng: 55.348974675058344 },
    { lat: 25.26377187437687, lng: 55.33681679774014 },
    { lat: 25.25583241010412, lng: 55.337265027719354 },
    { lat: 25.249168367662833, lng: 55.34939696414318 },
    { lat: 25.24784219165508, lng: 55.34965571459864 },
    { lat: 25.244526688303623, lng: 55.354270097722946 },
    { lat: 25.24460470118683, lng: 55.35668510197408 },
    { lat: 25.24281510695917, lng: 55.36127292290641 },
    { lat: 25.242659078845477, lng: 55.36536980511852 },
    { lat: 25.230774636693354, lng: 55.39096944280337 },
    { lat: 25.230164548564275, lng: 55.39403925414024 },
    { lat: 25.230206750744884, lng: 55.39685717667817 },
    { lat: 25.233151974475845, lng: 55.40343866613506 },
    { lat: 25.23565535855093, lng: 55.40325261696373 },
    { lat: 25.24006369890644, lng: 55.40386259439336 },
  ],
  [
    { lat: 24.92530739420428, lng: 55.11267234914027 },
    { lat: 24.915121657123464, lng: 55.129883618607494 },
    { lat: 24.899485315504847, lng: 55.11933684762491 },
    { lat: 24.88004463464516, lng: 55.154712265460574 },
    { lat: 24.866384140703374, lng: 55.14544199332988 },
    { lat: 24.855346394507123, lng: 55.169516723017836 },
    { lat: 24.88486106541761, lng: 55.19928428156496 },
    { lat: 24.92583508996522, lng: 55.22533384032266 },
    { lat: 24.931949606844825, lng: 55.22125923654647 },
    { lat: 24.95075769897484, lng: 55.19567017256901 },
    { lat: 24.961805562572025, lng: 55.165490673352 },
    { lat: 24.948531917161148, lng: 55.15541798786566 },
    { lat: 24.957192218742236, lng: 55.13797327377617 },
    { lat: 24.92530739420428, lng: 55.11267234914027 },
  ],
];
